import React from 'react';
import { useSelector } from 'react-redux';
import { Card, Col, Row } from 'react-bootstrap';
import { Store } from 'types/store';
import RenewalPrice from '../atoms/RenewalPrice';

interface Props {
  smallHeader: string;
  mainHeader: string;
  // Callers pass the result of `condition && value`, so false is a valid "nothing to show".
  description?: string | false | null;
  price?: number | null;
  priceWas?: number | false | null;
  combinedPaymentsCard?: boolean;
}

const PaymentHeader = ({ smallHeader, mainHeader, description = null, price, priceWas = null, combinedPaymentsCard = false }: Props) => {
  const { monthlyFlex } = useSelector((state: Store) => state.expiryRenewal);
  const { isMonthlyLongerTermPolicy } = useSelector((state: Store) => state.expiryRenewal.pageModel) ?? {};
  const isMonthly = isMonthlyLongerTermPolicy || monthlyFlex;
  const periodLabel = isMonthly ? '/month' : '/year';

  return (
    <Card className="card border-0 py-0 px-1 mb-3">
      <Row className="align-items-start">
        <Col xs={7}>
          <small className="text-muted mb-0 fw-normal">
            {smallHeader}
          </small>
          <h3 className="mb-3 fw-bold">
            {mainHeader}
          </h3>
        </Col>
        <Col xs={5} className="text-end mt-4 lh-1">
          {price && (
          <RenewalPrice
            size="lg"
            price={price}
            period={combinedPaymentsCard ? '' : periodLabel}
            wasPrice={priceWas}
            wasLabel="Was"
          />
          )}
        </Col>
      </Row>
      <Row className="align-items-start">
        <Col>
          {description && (
          <small className="mb-1 text-muted lh-base">
            {description}
          </small>
          )}
        </Col>
      </Row>
    </Card>
  )
};

export default PaymentHeader;
